import { TranslationKey } from "types";

export enum DeploymentType {
  SimpleDeployment = "SimpleDeployment",
  MultiSiteDeployment = "MultiSiteDeployment",
  MassiveScaleDeployment = "MassiveScaleDeployment",
}

export enum FullStackNetworkingType {
  Hardware = "hardware",
  Software = "software",
}

export enum ModelCompareTab {
  Switching = "Switching",
  AccessPoints = "AccessPoints",
  Cameras = "Cameras",
  DoorAccess = "DoorAccess",
}

export enum DeploymentVariant {
  Compact = "Compact",
  RackMount = "RackMount",
  MultiSite = "MultiSite",
  MassiveScale = "MassiveScale",
}

export interface IDeploymentTab {
  id: DeploymentType;
  label: string;
  icon: React.ReactNode;
  iconStyle: IIconProperties;
  href: string;
}

interface IIconProperties {
  width: string;
  height: string;
}

export interface IDeploymentVersionTab {
  id: DeploymentVariant;
  label: TranslationKey;
  href: string;
}
